import React from "react";
import { QrCode, Loader2 } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

/**
 * Big, mobile-friendly QR display for the customer to show the driver at pickup.
 * The PNG is rendered server-side and contains only the raw qr_token (no URL).
 */
export default function BookingQRCard({ qrToken, bookingNumber, status, className = "" }) {
  const [loaded, setLoaded] = React.useState(false);
  const [err, setErr] = React.useState(false);
  if (!qrToken) return null;

  const src = `${BACKEND}/api/track/qr/${qrToken}.png`;
  const completed = status === "delivered";

  return (
    <div className={`bg-white border-2 border-brand-dark ${className}`} data-testid="booking-qr-card">
      <div className="bg-brand-dark text-white px-5 sm:px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <QrCode size={18} className="text-brand-red" />
          <div>
            <div className="text-[10px] tracking-[0.2em] uppercase text-white/60">Din afhentnings-kode</div>
            <div className="font-display font-semibold text-base">Vis denne til chaufføren</div>
          </div>
        </div>
        <div className="text-right">
          <div className="text-[10px] tracking-[0.2em] uppercase text-white/60">Booking</div>
          <div className="font-mono font-bold text-sm">{bookingNumber}</div>
        </div>
      </div>

      <div className="px-5 sm:px-6 py-7 flex flex-col items-center gap-4">
        <div className={`relative w-[240px] h-[240px] sm:w-[280px] sm:h-[280px] flex items-center justify-center ${completed ? "opacity-40" : ""}`}>
          {!loaded && !err && (
            <div className="absolute inset-0 flex items-center justify-center bg-brand-bg2">
              <Loader2 size={28} className="animate-spin text-brand-text2" />
            </div>
          )}
          {err && (
            <div className="absolute inset-0 flex items-center justify-center text-brand-text2 text-sm text-center px-4">
              Kunne ikke hente QR. Genindlæs siden.
            </div>
          )}
          <img
            src={src}
            alt={`QR-kode for ${bookingNumber}`}
            onLoad={() => setLoaded(true)}
            onError={() => setErr(true)}
            className={`w-full h-full object-contain transition-opacity ${loaded ? "opacity-100" : "opacity-0"}`}
            data-testid="booking-qr-img"
          />
        </div>

        {completed ? (
          <p className="text-center text-brand-text2 text-sm max-w-xs">
            Pakken er leveret. QR-koden er ikke længere aktiv.
          </p>
        ) : (
          <div className="text-center max-w-xs space-y-2">
            <p className="text-brand-dark font-semibold text-sm">
              Hold telefonen klar når chaufføren ankommer — koden scannes på 2 sekunder.
            </p>
            <p className="text-brand-text2 text-xs leading-relaxed">
              Sikker bekræftelse på at det er din pakke der hentes.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
